import * as React from 'react';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { WIDGET_OPTIONS } from '../../config/constants';

const Router: React.FC = ({ children }) => {
  const enableHashRouter = WIDGET_OPTIONS?.enableHashRouter;

  if (enableHashRouter) {
    return (
      <HashRouter>
        {children}
      </HashRouter>
    );
  }

  return (
    <BrowserRouter>
      {children}
    </BrowserRouter>
  );
};

export default Router;
